<template>
  <div class="order s-new-theme">
    <div class="order-task">
      <div v-for="(item,index) in taskList" :key="index" class="task-one" :class="item.process? 'finished': index === 2?'ing':''">
        {{index+1}}.{{item.name}}
        <div class="box">
          <div v-if="!item.process"></div>
          <i v-else class="icon iconfont icon-duigou" style="color:#fff;"></i>
        </div>
      </div>
      <!-- <div class="task-one">
        完成
        <div class="box"><div></div></div>
      </div> -->
      <div class="line"></div>
    </div>
    <div class="order-header">
      <p>参展申请</p>
      <span></span>
      <p>选择订单</p>
    </div>

    <!-- 展区 -->
    <div class="order-exhall">
      <p class="exhall-header" v-if="orderInfo && orderInfo.isAgent === '否'">请选择您要参展的展区</p>
      <p class="exhall-header" v-if="orderInfo && orderInfo.isAgent === '是'">请选择组团</p>
      <div class="exhall-list">
        <template v-if="list && list.length > 0">
          <div class="list-one" v-for="(item,index) in list" :key="index" @click="select(item)" :class="selectedExhall.id === item.id?'selected':''" v-if="item.typeLanguage=='中文'">
            {{item.name}}

          </div>
          <Input v-model="remark" placeholder="请输入产品类型" v-if="inputShow" style="width:300px" />
        </template>
        <div v-else style="width:100%;line-height:200px;text-align:center;">暂无数据！</div>
      </div>
      <p class="exhall-header" v-if="orderInfo && orderInfo.isAgent === '否'">请选择展位类型</p>
      <p class="exhall-header" v-if="orderInfo && orderInfo.isAgent === '是'">请选择组团类型</p>
      <div class="booth-list">
        <template v-if="boothList && boothList.length">
          <div class="booth-one" :class="chooseBooth && chooseBooth.id === item.id?'chooseboothOne':''" v-for="(item,index) in boothList" :key="index" @click="choose(item)">
            <div class="f">
              <p>{{item.pjName}}</p>

              <p v-if="item.remarkList&&item.remarkList.length>0">{{item.remarkList[0]}}</p>
              <p v-else></p>
            </div>
            <div>
              <p v-if="item.remarkList&&item.remarkList.length>1" style="color:red">{{item.remarkList[1]}}</p>
            </div>
            <div class="s">
              <!-- <p>媒体推广费 RMB 3400.00</p> -->
              <p></p>
              <p v-if="orderInfo && orderInfo.isAgent === '否'">{{item.price}}{{item.pType}}/{{item.cunit}}</p>
            </div>
            <div class="t">
              面宽：<InputNumber :max="999999999" :min="0" v-model="item.width1" @on-change="v => changeWidth1(v,index)"></InputNumber> ×
              进深：<InputNumber :max="999999999" :min="0" v-model="item.width2" @on-change="v => changeWidth2(v,index)">></InputNumber> =
              {{item.width1*item.width2}} ㎡
            </div>
            <div class="l" v-if="orderInfo && orderInfo.isAgent === '否'">
              <span v-if="item.standstall>1&&(item.cunit.indexOf('㎡')!=-1||item.cunit.indexOf('平米')!=-1||item.cunit.indexOf('平方米')!=-1||item.cunit.indexOf('sqm')!=-1)">合计：{{(item.width1*item.width2*item.price/item.standstall).toFixed()}}{{item.pType}}</span>
              <span v-else>合计：{{item.width1*item.width2*item.price}} {{item.pType}}</span>
            </div>
            <div class="choose" :class="chooseBooth && chooseBooth.id === item.id?'choosed':''">
              <i class="icon iconfont icon-duigou"></i>
            </div>
          </div>
        </template>
        <div v-else style="width:100%;line-height:200px;text-align:center;">暂无数据！</div>
      </div>
    </div>
    <!-- {{chooseBooth}} -->
    <!-- {{selectedExhall}} -->
    <div class="order-other">
      <p class="other-header" style="margin-bottom:30px;">固定费用</p>

      <template v-if="otherList3 && otherList3.length > 0&&join==false">
        <div class="other-list" v-for="(item,index) in otherList3" :key="'other' + index" v-if="item.typeLanguage==='中文'">
          <!-- <div class="top">
            <div class="l" v-if="item.name">
              <Checkbox size="large"  v-model="item.isCheck" :disabled=true></Checkbox> 
              {{item.name}}
            </div>
          </div> -->
          <template v-if="item.isPack">
            <div class="content" v-if="item.dePjNameList && item.dePjNameList.length > 0">
              <div class="content-one chooseboothOne" v-for="(itm,idx) in item.dePjNameList" :key="idx">
                <div class="title">{{itm.pjName}}</div>
                <div class="details">
                  <div class="text">
                    <div class="time">
                    </div>
                    <div class="time" v-if="orderInfo">
                      <span>单价</span>
                      <p style="padding:5px 0;background:#fff;color:#db2a4b;font-size:14px;">{{itm.price}}{{itm.pType}}/{{itm.cunit}}</p>
                    </div>
                    <div class="time">
                      <span>个数</span>
                      <InputNumber @click.stop.native style="width:100px;" :max="9999999999" @on-change="changeNumber(itm,$event)" :min="0" v-model="itm.minCount" :disabled=true></InputNumber>&nbsp;&nbsp;&nbsp;{{itm.cunit}}
                    </div>
                    <!-- <p style="margin-top:30px;" v-if="orderInfo">总价: {{itm.minCount*itm.price}} {{itm.pType}}</p> -->
                    <div class="choose choosed">
                      <i class="icon iconfont icon-duigou"></i>
                    </div>
                  </div>

                  <img v-if="itm.netImg" :src="itm.netImg" />
                </div>
              </div>
            </div>
            <div v-else style="width:100%;line-height:200px;text-align:center;">暂无数据！</div>
          </template>
        </div>
      </template>

      <template v-else-if="otherList3 && otherList3.length > 0&&join==true">
        <div class="other-list" v-for="(item,index) in otherList3" :key="'other' + index" v-if="item.typeLanguage==='中文'">
          <!-- <div class="top"> -->
          <!-- <div class="l" @click="allChoose(item)" :class="isAllChoose.indexOf(item.id) !== -1?'l-clicked':''">
              <i class="icon iconfont icon-duigou"></i>
            </div> -->
          <!-- <div class="l" v-if="item.name"> -->
          <!-- <Checkbox size="large" @on-change="allChoose(item, $event)"  v-model="item.isCheck"></Checkbox> -->
          <!-- {{item.name}}
            </div> -->
          <!-- <div class="r" v-if="!item.isPack" @click="item.isPack = !item.isPack">
              Show More
              <i class="icon iconfont icon-expanding" style="transform:rotate(90deg);"></i>
            </div>
            <div class="r" v-else @click="item.isPack = !item.isPack">
             Show Less
              <i class="icon iconfont icon-expanding" style="transform:rotate(-90deg);"></i>
            </div> -->
          <!-- </div> -->
          <template v-if="item.isPack">
            <div class="content" v-if="item.dePjNameList && item.dePjNameList.length > 0">
              <div class="content-one" v-for="(itm,idx) in item.dePjNameList" :key="idx">
                <div class="title">{{itm.pjName}}</div>
                <div class="details">
                  <!-- <div class="text" @click="chooseOne(itm,index)"> -->
                  <div class="text" >
                    <div class="time">
                    </div>
                    <div class="time" v-if="orderInfo">
                      <span>单价</span>
                      <p style="padding:5px 0;background:#fff;color:#db2a4b;font-size:14px;">{{itm.price}}{{itm.pType}}/{{itm.cunit}}</p>
                    </div>
                    <div class="time">
                      <span>个数</span>
                      <InputNumber @click.stop.native style="width:100px;" :max="9999999999" @on-change="changeNumber(itm,$event)" :min="0" v-model="itm.minCount" :disabled=true></InputNumber>&nbsp;&nbsp;&nbsp;{{itm.cunit}}
                    </div>
                    <p style="margin-top:30px;" v-if="orderInfo">总价: {{itm.minCount*itm.price}} {{itm.pType}}</p>
                    <!-- <div class="choose " :class="chooseOtherArr.indexOf(itm) !== -1?'choosed':''">
                      <i class="icon iconfont icon-duigou"></i>
                    </div> -->
                    <div class="choose" :class="chooseOtherArr.indexOf(itm) !== -1?'choosed':''">
                      <i class="icon iconfont icon-duigou"></i>
                    </div>
                  </div>

                  <img v-if="itm.netImg" :src="itm.netImg" />
                </div>
              </div>
            </div>
            <div v-else style="width:100%;line-height:200px;text-align:center;">暂无数据！</div>
          </template>
        </div>
      </template>
      <div v-else style="width:100%;line-height:200px;text-align:center;">暂无数据！</div>

    </div>
    <!-- 增值服务 -->
    <div class="order-other">
      <p class="other-header" style="margin-bottom:30px;">请选择线上/线下市场增值服务项目</p>
      <div class="other-online" v-if="onlineFile && onlineFile.downloadLink">
        线上赞助项目：
        <a :href="onlineFile.downloadLink" download target="_blank">点击下载线上市场增值服务详情文件</a>
      </div>
      <template v-if="otherList && otherList.length > 0">
        <div class="other-list" v-for="(item,index) in otherList" :key="'other' + index" v-if="item.typeLanguage==='中文'">
          <div class="top">
            <!-- <div class="l" @click="allChoose(item)" :class="isAllChoose.indexOf(item.id) !== -1?'l-clicked':''">
              <i class="icon iconfont icon-duigou"></i>
            </div> -->
            <div class="l">
              <Checkbox size="large" @on-change="allChoose(item, $event)" v-model="item.isCheck"></Checkbox>
              {{item.name}}
            </div>
            <div class="r" v-if="!item.isPack" @click="item.isPack = !item.isPack">
              展开
              <i class="icon iconfont icon-expanding" style="transform:rotate(90deg);"></i>
            </div>
            <div class="r" v-else @click="item.isPack = !item.isPack">
              收起
              <i class="icon iconfont icon-expanding" style="transform:rotate(-90deg);"></i>
            </div>
          </div>
          <template v-if="item.isPack">
            <div class="content" v-if="item.dePjNameList && item.dePjNameList.length > 0">
              <div class="content-one" v-for="(itm,idx) in item.dePjNameList" :key="idx">
                <div class="title">{{itm.pjName}}</div>
                <div class="details">
                  <div class="text" @click="chooseOne(itm,index)" v-if="item.netShow !=='显示且必选'">
                    <div class="time">
                      <span v-if="itm.durationType === '时间段'">选择时间段</span>
                      <span v-if="itm.durationType === '时长'">选择时长</span>
                      <DatePicker v-if="itm.durationType === '时间段'" format="yyyy-MM-dd" style="width:230px;" type="datetimerange" placeholder="开始时间 ~ 结束时间" :options="itm.options" v-model="itm.durationValue" @click.stop.native></DatePicker>
                      <template v-if="itm.durationType === '时长'">
                        <Select v-model="itm.durationValue" style="width:100px" @click.stop.native>
                          <Option v-for="im in itm.durationList" :value="im" :key="im">{{ im }}</Option>
                        </Select>&nbsp;&nbsp;&nbsp;{{itm.durationUnit}}
                      </template>
                    </div>
                    <div class="time" v-if="orderInfo">
                      <span>价格</span>
                      <p style="padding:5px 0;background:#fff;color:#db2a4b;font-size:14px;">{{itm.price}}{{itm.pType}}/{{itm.cunit}}</p>
                    </div>
                    <div class="time">
                      <span>订购数量</span>
                      <InputNumber @click.stop.native style="width:100px;" :max="9999999999" @on-change="changeNumber(itm,$event)" :min="0" v-model="itm.orderNum"></InputNumber>&nbsp;&nbsp;&nbsp;{{itm.cunit}}
                    </div>
                    <p style="margin-top:30px;" v-if="orderInfo">合计: {{itm.orderNum*itm.price}} {{itm.pType}}</p>
                    <div class="choose" :class="chooseOtherArr.indexOf(itm) !== -1?'choosed':''">
                      <i class="icon iconfont icon-duigou"></i>
                    </div>
                  </div>
                  <div class="text" v-else>
                    <div class="time">
                      <span v-if="itm.durationType === '时间段'">选择时间段</span>
                      <span v-if="itm.durationType === '时长'">选择时长</span>
                      <DatePicker v-if="itm.durationType === '时间段'" format="yyyy-MM-dd" style="width:230px;" type="datetimerange" placeholder="开始时间 ~ 结束时间" :options="itm.options" v-model="itm.durationValue" @click.stop.native :disabled="true"></DatePicker>
                      <template v-if="itm.durationType === '时长'">
                        <Select v-model="itm.durationValue" style="width:100px" @click.stop.native :disabled="true">
                          <Option v-for="im in itm.durationList" :value="im" :key="im">{{ im }}</Option>
                        </Select>&nbsp;&nbsp;&nbsp;{{itm.durationUnit}}
                      </template>
                    </div>
                    <div class="time" v-if="orderInfo">
                      <span>价格</span>
                      <p style="padding:5px 0;background:#fff;color:#db2a4b;font-size:14px;">{{itm.price}}{{itm.pType}}/{{itm.cunit}}</p>
                    </div>
                    <div class="time">
                      <span>订购数量</span>
                      <InputNumber @click.stop.native style="width:100px;" :max="9999999999" :min="1" v-model="itm.orderNum" :disabled="true"></InputNumber>&nbsp;&nbsp;&nbsp;{{itm.cunit}}
                    </div>
                    <p style="margin-top:30px;" v-if="orderInfo">合计: {{itm.orderNum*itm.price}} {{itm.pType}}</p>
                    <div class="choose" :class="'choosed'">
                      <i class="icon iconfont icon-duigou"></i>
                    </div>
                  </div>
                  <img v-if="itm.netImg" :src="itm.netImg" />
                </div>
              </div>
            </div>
            <div v-else style="width:100%;line-height:200px;text-align:center;">暂无数据！</div>
          </template>
        </div>
      </template>
      <div v-else style="width:100%;line-height:200px;text-align:center;">暂无数据！</div>

      <div class="other-online" v-if="offlineFile && offlineFile.downloadLink">
        线下赞助项目：
        <a :href="offlineFile && offlineFile.downloadLink?offlineFile.downloadLink:''">点击下载线下市场增值服务详情文件</a>
      </div>
      <template v-if="otherList2 && otherList2.length > 0">
        <div class="other-list" v-for="(item,index) in otherList2" :key="'other2' + index">
          <div class="top">
            <!-- <div class="l" @click="allChoose(item)" :class="isAllChoose.indexOf(item.id) !== -1?'l-clicked':''">
              <i class="icon iconfont icon-duigou"></i>
            </div> -->
            <div class="l">
              <Checkbox size="large" @on-change="allChoose(item, $event)" v-model="item.isCheck"></Checkbox>
              {{item.name}}
            </div>
            <div class="r" v-if="!item.isPack" @click="item.isPack = !item.isPack">
              展开
              <i class="icon iconfont icon-expanding" style="transform:rotate(90deg);"></i>
            </div>
            <div class="r" v-else @click="item.isPack = !item.isPack">
              收起
              <i class="icon iconfont icon-expanding" style="transform:rotate(-90deg);"></i>
            </div>
          </div>
          <template v-if="item.isPack">
            <div class="content" v-if="item.dePjNameList && item.dePjNameList.length > 0">
              <div class="content-one" v-for="(itm,idx) in item.dePjNameList" :key="idx">
                <div class="title">{{itm.pjName}}</div>
                <div class="details">
                  <div class="text" @click="chooseOne(itm,index)" v-if="item.netShow !=='显示且必选'">
                    <div class="time">
                      <span v-if="itm.durationType === '时间段'">选择时间段</span>
                      <span v-if="itm.durationType === '时长'">选择时长</span>
                      <DatePicker v-if="itm.durationType === '时间段'" format="yyyy-MM-dd" style="width:230px;" type="datetimerange" placeholder="开始时间 ~ 结束时间" :options="itm.options" v-model="itm.durationValue" @click.stop.native></DatePicker>
                      <template v-if="itm.durationType === '时长'">
                        <Select v-model="itm.durationValue" style="width:100px" @click.stop.native>
                          <Option v-for="im in itm.durationList" :value="im" :key="im">{{ im }}</Option>
                        </Select>&nbsp;&nbsp;&nbsp;{{itm.durationUnit}}
                      </template>
                    </div>
                    <div class="time" v-if="orderInfo">
                      <span>价格</span>
                      <p style="padding:5px 0;background:#fff;color:#db2a4b;font-size:14px;">{{itm.price}}{{itm.pType}}/{{itm.cunit}}</p>
                    </div>
                    <div class="time">
                      <span>订购数量</span>
                      <InputNumber @click.stop.native style="width:100px;" :max="9999999999" @on-change="changeNumber(itm,$event)" :min="0" v-model="itm.orderNum"></InputNumber>&nbsp;&nbsp;&nbsp;{{itm.cunit}}
                    </div>
                    <p style="margin-top:30px;" v-if="orderInfo">合计: {{itm.orderNum*itm.price}} {{itm.pType}}</p>
                    <div class="choose" :class="chooseOtherArr.indexOf(itm) !== -1?'choosed':''">
                      <i class="icon iconfont icon-duigou"></i>
                    </div>
                  </div>
                  <div class="text" v-else>
                    <div class="time">
                      <span v-if="itm.durationType === '时间段'">选择时间段</span>
                      <span v-if="itm.durationType === '时长'">选择时长</span>
                      <DatePicker v-if="itm.durationType === '时间段'" format="yyyy-MM-dd" style="width:230px;" type="datetimerange" placeholder="开始时间 ~ 结束时间" :options="itm.options" v-model="itm.durationValue" @click.stop.native :disabled="true"></DatePicker>
                      <template v-if="itm.durationType === '时长'">
                        <Select v-model="itm.durationValue" style="width:100px" @click.stop.native :disabled="true">
                          <Option v-for="im in itm.durationList" :value="im" :key="im">{{ im }}</Option>
                        </Select>&nbsp;&nbsp;&nbsp;{{itm.durationUnit}}
                      </template>
                    </div>
                    <div class="time" v-if="orderInfo">
                      <span>价格</span>
                      <p style="padding:5px 0;background:#fff;color:#db2a4b;font-size:14px;">{{itm.price}}{{itm.pType}}/{{itm.cunit}}</p>
                    </div>
                    <div class="time">
                      <span>订购数量</span>
                      <InputNumber @click.stop.native style="width:100px;" :max="9999999999" :min="1" v-model="itm.orderNum" :disabled="true"></InputNumber>&nbsp;&nbsp;&nbsp;{{itm.cunit}}
                    </div>
                    <p style="margin-top:30px;" v-if="orderInfo">合计: {{itm.orderNum*itm.price}} {{itm.pType}}</p>
                    <div class="choose" :class="'choosed'">
                      <i class="icon iconfont icon-duigou"></i>
                    </div>
                  </div>
                  <img v-if="itm.netImg" :src="itm.netImg" />
                </div>
              </div>
            </div>
            <div v-else style="width:100%;line-height:200px;text-align:center;">暂无数据！</div>
          </template>
        </div>
      </template>
      <div v-else style="width:100%;line-height:200px;text-align:center;">暂无数据！</div>
      <div class="total" v-if='join'>
        <p>线上线下市场增值服务订单小计： <span>{{otherTotalPrice}}</span>元</p>
        <p style="margin-top:20px;">展位订单小计： <span>
            <template v-if="chooseBooth&&chooseBooth.standstall<=1">{{chooseBooth.width1*chooseBooth.width2*chooseBooth.price}}</template>
            <template v-else-if="chooseBooth&&chooseBooth.standstall>1&&(chooseBooth.cunit.indexOf('㎡')!=-1||chooseBooth.cunit.indexOf('平米')!=-1||chooseBooth.cunit.indexOf('平方米')!=-1)">{{(chooseBooth.width1*chooseBooth.width2*chooseBooth.price/chooseBooth.standstall).toFixed()}}</template>
            <template v-else>0</template></span> 元</p>
        <p style="margin-top:20px;">固定费用: <span>{{gudingprice}}</span>元 </p>
        <p style="margin-top:20px;">订单合计:
          <span style="font-size:20px;font-weight:bold;">
            <template v-if="chooseBooth&&chooseBooth.standstall<=1">{{chooseBooth.width1*chooseBooth.width2*chooseBooth.price + otherTotalPrice+gudingprice}}</template>
            <template v-else-if="chooseBooth&&chooseBooth.standstall>1&&(chooseBooth.cunit.indexOf('㎡')!=-1||chooseBooth.cunit.indexOf('平米')!=-1||chooseBooth.cunit.indexOf('平方米')!=-1)">{{(chooseBooth.width1*chooseBooth.width2*chooseBooth.price/chooseBooth.standstall+ otherTotalPrice+gudingprice).toFixed() }}</template>
            <template v-else>{{otherTotalPrice+gudingprice}}</template>
          </span> 元
        </p>
      </div>
      <div class="total" v-else>
        <p>线上线下市场增值服务订单小计： <span>{{otherTotalPrice}}</span> 元</p>
        <p style="margin-top:20px;">展位订单小计： <span>
            <template v-if="chooseBooth&&chooseBooth.standstall<=1">{{chooseBooth.width1*chooseBooth.width2*chooseBooth.price}}</template>
            <template v-else-if="chooseBooth&&chooseBooth.standstall>1&&(chooseBooth.cunit.indexOf('㎡')!=-1||chooseBooth.cunit.indexOf('平米')!=-1||chooseBooth.cunit.indexOf('平方米')!=-1)">{{(chooseBooth.width1*chooseBooth.width2*chooseBooth.price/chooseBooth.standstall).toFixed()}}</template>
            <template v-else>0</template>
          </span> 元</p>
        <p style="margin-top:20px;">固定费用: <span>{{gudingprice}}</span>元 </p>
        <p style="margin-top:20px;">订单合计：
          <span style="font-size:20px;font-weight:bold;">
            <template v-if="chooseBooth&&chooseBooth.standstall<=1">{{chooseBooth.width1*chooseBooth.width2*chooseBooth.price + otherTotalPrice+gudingprice}}</template>
            <template v-else-if="chooseBooth&&chooseBooth.standstall>1&&(chooseBooth.cunit.indexOf('㎡')!=-1||chooseBooth.cunit.indexOf('平米')!=-1||chooseBooth.cunit.indexOf('平方米')!=-1)">{{(chooseBooth.width1*chooseBooth.width2*chooseBooth.price/chooseBooth.standstall+ otherTotalPrice+gudingprice).toFixed() }}</template>
            <template v-else>{{otherTotalPrice+gudingprice}}</template>
          </span> 元
        </p>
      </div>
    </div>
    <!-- {{chooseOtherArr}} -->

    <div class="order-btn">
      <Button type="primary" class="s-btn-red" size="large" @click="goBack" style="margin-right:30px;">上一步</Button>
      <Button type="primary" class="s-btn-red" size="large" @click="goNext" :loading="loading">保存并下一步</Button>
    </div>
    <!-- {{isAllChoose}} -->

    <iModal cancel-text title="" width="416" v-model="isChange" :closable="false" :footer-hide="true">
      <div class="change-modal">
        <div class="change-modal-top">
          <Icon type="ios-alert" color="#f90" size="28" />
          <p>确认</p>
        </div>
        <div class="change-modal-bottom">
          <p v-if="chooseBooth">您确定要放弃订购{{chooseBooth.pjName}}展位吗 ？</p>
        </div>
        <div class="change-modal-btn">
          <Button type="text" @click="isChange=false;middleInfo=null;">取消</Button>
          <Button type="primary" @click="confirm()" style="margin-left:10px;">确定</Button>
        </div>
      </div>
    </iModal>


    <iModal cancel-text title="" width="416" v-model="errorMsgBool" :mask-closable="false" :closable="false" :footer-hide="true">
      <div class="change-modal">
        <div class="change-modal-top">
          <Icon type="ios-alert" color="red" size="28" />
          <p>确认</p>
        </div>
        <div class="change-modal-bottom">
          <p >{{msgErrors }}</p>
        </div>
        <div class="change-modal-btn">
          <!-- <Button type="text" @click="isChange=false;middleInfo=null;">取消</Button> -->
          <Button type="primary" @click="goBack()" style="margin-left:10px;">确定</Button>
        </div>
      </div>
    </iModal>



  </div>
</template>

<script>
import { mapActions } from "vuex";
let moment = require("moment");

export default {
  name: "order",
  data () {
    return {
        msgErrors:'',
        errorMsgBool:false,

      taskList: [],
      speenInfo: null,
      loading: false,
      list: [],
      boothList: [],
      selectedExhall: null,
      chooseBooth: null,
      otherList: [], // 线上增值服务
      otherList2: [], // 线下增值服务
      otherList3: [],
      chooseOtherArr: [], // 选中的增值服务
      isAllChoose: [], // 是否全选
      orderInfo: null,
      isChange: false,
      middleInfo: null,
      otherTotalPrice: 0,
      onlineFile: null,
      offlineFile: null,
      ChooseCheck: false,
      join: false,//是否参加过
      fixedId: 0,
      gudingprice: 0,
      inputShow: false,//是否显示输入框
      remark: ""
    };
  },
  components: {
  },
  computed: {
    exhibitionId () {
      return this.$route.query.id;
    },
    applyCompanyId () {
      return this.$route.query.applyCompanyId;
    },
    applyCompanyOrderId () {
      return this.$route.query.applyCompanyOrderId;
    },
    groupId () {
      return this.$route.query.groupId;
    }

  },
  methods: {
    ...mapActions({
      getApplyFlow: "getApplyFlow",
      getApplyFlowSpeed: "getApplyFlowSpeed",
      getDePjNameGroup: "getDePjNameGroup",
      addApplyOrder: "addApplyOrder",
      getOrderDetail: "getOrderDetail",
      editApplyOrder: "editApplyOrder",
      getDeTerm: "getDeTerm",
      getGroupInfoById: "getGroupInfoById",
      getFile: "getFile",
      getjoin: 'getjoin'
    }),
    async init () {
      console.log(this.chooseOtherArr, ' this.chooseOtherArr12312312')
      this.chooseOtherArr = Array.from(new Set(this.chooseOtherArr))
      console.log(this.chooseOtherArr, ' this.chooseOtherArr.')
      let opt = {
        ExhibitionId: this.exhibitionId,
        ApplyCompanyId: this.applyCompanyId
      }
      let data = await this.getjoin(opt)//获取是否参加过上一届展会
      if (data.successed) {
        this.join = data.info
        //this.join=true
      }
      // 流程
      let taskList = await this.getApplyFlow();
      this.taskList = taskList;
      let info = await this.getApplyFlowSpeed(this.applyCompanyId);
      if (info && info.info) {
        this.speenInfo = info.info;
        if (this.taskList && this.taskList.length > 0) {
          this.taskList.map(c => {
            if (this.speenInfo && this.speenInfo.speed >= c.speed) {
              c.process = true;
            }
          })
        }
      }
      // this.speenInfo不存在，即此轮流程已结束
      if (!this.speenInfo) {
        if (this.applyCompanyOrderId) {
          this.$router.push("/join/basic?applyCompanyId=" + this.applyCompanyId + "&applyCompanyOrderId=" + this.applyCompanyOrderId);
        } else {
          this.$router.push("/join/basic?applyCompanyId=" + this.applyCompanyId);
        }
      }

      // 展会下载文件
      let onlineFile = await this.getFile({
        "ExhibitionId": this.exhibitionId,
        "Name": "线上市场增值服务详情文件"
      });
      if (onlineFile) {
        this.onlineFile = onlineFile;
      }
      let offlineFile = await this.getFile({
        "ExhibitionId": this.exhibitionId,
        "Name": "线下市场增值服务详情文件"
      });
      if (offlineFile) {
        this.offlineFile = offlineFile;
      }

      // 订单信息
      let orderInfo = await this.getOrderDetail(this.applyCompanyOrderId);
      if (orderInfo && orderInfo.applyFileLink) {
        this.$router.replace("/join/finish");
      }
      this.orderInfo = orderInfo;
      console.log("订单信息：", this.orderInfo);
      if (this.orderInfo.isAgent === "是") {
        // 组团
        let deTerm = await this.getGroupInfoById(this.groupId);
        if (deTerm && deTerm.length) {
          if (deTerm[0].dePjNameList.length > 0) {
            this.boothList = deTerm[0].dePjNameList;
            if (this.boothList.length > 0) {
              this.boothList.map(c => {
                c.width1 = 0;
                c.width2 = 0;
              })
            }
            this.selectedExhall = deTerm[0];
          }
          this.list = deTerm;

        }
      } else {

        // 展位、增值服务
        let list = await this.getDePjNameGroup({
          "IsBoothGroup": "是",
          "typeLanguage": "中文",
          "ExhibitionId": this.exhibitionId
        }); // 是：展区选择展位； 否：增值服务项目
        console.log(list, '数组');
        if (list && list.length) {
          if (list[0].dePjNameList.length > 0) {
            this.boothList = list[0].dePjNameList;
            if (this.boothList.length > 0) {
              this.boothList.map(c => {
                c.width1 = 0;
                c.width2 = 0;
              })
            }
            this.selectedExhall = list[0];
          }
        }
        //如果有订单默认选中
        if (this.orderInfo && this.orderInfo.applyBoothOrderList.length && list) {


          list.forEach(c => {
            if (c.dePjNameList.length > 0) {

              c.dePjNameList.forEach(e => {
                if (e.pjName == this.orderInfo.applyBoothOrderList[0].name) {
                  this.boothList = c.dePjNameList
                  this.chooseBooth = e;

                  this.boothList.map(d => {
                    d.width1 = 0;
                    d.width2 = 0;
                  })
                  if (this.chooseBooth) {
                    this.chooseBooth.width1 = this.orderInfo.applyBoothOrderList[0].width
                    this.chooseBooth.width2 = this.orderInfo.applyBoothOrderList[0].height
                  }

                }

              })
            }
            if (c.id == this.orderInfo.applyBoothOrderList[0].dePjNameGroupId) {
              this.selectedExhall = c
              console.log(this.selectedExhall, '这个是选中的数据');
              if (this.selectedExhall.name.indexOf('其他') != -1) {
                this.inputShow = true
                this.remark = orderInfo.remark
              }
            }
          })
        }
        this.list = list;
        
        console.log(this.selectedExhall, 'this.selectedExhall');
        console.log(this.boothList, '12222223');
      }
      let otherList3 = await this.getDePjNameGroup({
        "IsBoothGroup": "否",
        "typeLanguage": "中文",
        "ExhibitionId": this.exhibitionId,
        "Type": "固定费用"
      })
      console.log(otherList3, `otherList3`)
      this.otherList3 = otherList3
      for (let i = 0; i < this.otherList3.length; i++) {
        if (this.otherList3[i].typeLanguage === '中文') {
          this.fixedId = i
          for (let j = 0; j < this.otherList3[i].dePjNameList.length; j++) {
            this.gudingprice = this.otherList3[i].dePjNameList[j].price + this.gudingprice
          }
        }
      }

      console.log(this.otherList3[this.fixedId], 'this.gudingprice')
      this.otherList3.map(c => {
        c.isPack = true
        c.isCheck = true

      })

      if (this.join) {
        this.allChoose(this.otherList3[this.fixedId], true)
        //this.chooseOtherArr=this.otherList3[this.fixedId].dePjNameList
        this.otherList3[this.fixedId].dePjNameList.map((e) => {
          this.chooseOtherArr.push(e)
        })
      }
      else {
        this.otherList3[this.fixedId].dePjNameList.map((e) => {
          this.chooseOtherArr.push(e)
        })
      }

      let otherList = await this.getDePjNameGroup({
        "IsBoothGroup": "否",
        "typeLanguage": "中文",
        "ExhibitionId": this.exhibitionId,
        "Type": "线上"
      }); // 是：展区选择展位； 否：增值服务项目
      if (otherList && otherList.length > 0) {
        otherList.map(c => {
          c.isPack = false;
          c.isCheck = false;

          if (c.dePjNameList.length > 0) {
            c.dePjNameList.map(d => {
              d.orderNum = 0;
              d.durationValue = null;
              d.otherName = c.name;
              let start = new Date(d.durationBegin).getTime();
              let end = new Date(d.durationEnd).getTime();
              d.options = {
                disabledDate (date) {
                  const disabledDay = date.getTime();
                  if (disabledDay < start || disabledDay > end) {
                    return true;
                  } else {
                    return false;
                  }
                }
              }
            })
          }
        })
      }
      this.otherList = otherList;
      this.otherList.map((a) => {
        if (a.dePjNameList.length > 0) {
          a.dePjNameList.map((p) => {
            if (p.netShow == '显示且必选') {
              p.orderNum = 1;
              this.chooseOne(p)
            }
          })
        }

      })
      let otherList2 = await this.getDePjNameGroup({
        "IsBoothGroup": "否",
        "typeLanguage": "中文",
        "ExhibitionId": this.exhibitionId,
        "Type": "线下"
      }); // 是：展区选择展位； 否：增值服务项目
      if (otherList2 && otherList2.length > 0) {
        otherList2.map(c => {
          c.isPack = false;
          c.isCheck = false;
          if (c.dePjNameList.length > 0) {
            c.dePjNameList.map(d => {
              d.orderNum = 0;
              d.durationValue = null;
              d.otherName = c.name;
              let start = new Date(d.durationBegin).getTime();
              let end = new Date(d.durationEnd).getTime();
              d.options = {
                disabledDate (date) {
                  const disabledDay = date.getTime();
                  if (disabledDay < start || disabledDay > end) {
                    return true;
                  } else {
                    return false;
                  }
                }
              }

            })
          }
        })
      }
      this.otherList2 = otherList2;
      this.otherList2.map((a) => {
        if (a.dePjNameList.length > 0) {
          a.dePjNameList.map((p) => {
            if (p.netShow == '显示且必选') {
              p.orderNum = 1;
              this.chooseOne(p)
            }
          })
        }

      })
      console.log(this.otherList2, 'this.otherList2加载了')
      // 初始化展位订单
      if (this.orderInfo && this.orderInfo.applyBoothOrderList.length > 0) {
        if (this.list && this.list.length > 0) {
          this.list.map(a => {
            if (a.dePjNameList.length > 0) {
              a.dePjNameList.map(b => {
                if (b.dePjNameGroupId === this.orderInfo.applyBoothOrderList[0].dePjNameGroupId && b.pjName === this.orderInfo.applyBoothOrderList[0].name) {
                  this.selectedExhall = a;
                  this.chooseBooth = b;
                  this.chooseBooth.width1 = this.orderInfo.applyBoothOrderList[0].width;
                  this.chooseBooth.width2 = this.orderInfo.applyBoothOrderList[0].height;
                }
              })
            }
          })
        }
      }
      // 初始化增值服务订单
      if (this.orderInfo && this.orderInfo.applyOtherOrderList.length > 0) {
        if (this.otherList && this.otherList.length > 0) {
          this.otherList.map(a => {
            if (a.dePjNameList.length > 0) {
              a.dePjNameList.map(b => {
                if (this.orderInfo && this.orderInfo.applyOtherOrderList.length > 0) {
                  this.orderInfo.applyOtherOrderList.map(c => {
                    if (b.pjName === c.name) {
                      b.orderNum = c.quantity;
                      if (b.durationType === "时长") {
                        b.durationValue = String(c.duration);
                      }
                      if (b.durationType === "时间段") {
                        b.durationValue = [c.durationBegin, c.durationEnd];
                      }
                      this.otherTotalPrice += c.totalPrice;
                      this.chooseOtherArr.push(b);
                      this.isAllChoose.push(c.dePjNameGroupId)
                      a.isCheck = true;
                    }
                  })
                }
              })
            }
          })
          console.log(this.otherList, 'this.otherList')
        }
        if (this.otherList2 && this.otherList2.length > 0) {
          this.otherList2.map(a => {
            if (a.dePjNameList.length > 0) {
              a.dePjNameList.map(b => {
                if (this.orderInfo && this.orderInfo.applyOtherOrderList.length > 0) {
                  this.orderInfo.applyOtherOrderList.map(c => {
                    if (b.dePjNameGroupId === c.dePjNameGroupId) {
                      b.orderNum = c.quantity;
                      if (b.durationType === "时长") {
                        b.durationValue = String(c.duration);
                      }
                      if (b.durationType === "时间段") {
                        b.durationValue = [c.durationBegin, c.durationEnd];
                      }
                      this.chooseOtherArr.push(b);
                      a.isCheck = true;
                    }
                  })
                }
              })
            }
          })
        }
        console.log(this.otherList2, 'this.otherList2')
      }
    },
    goBack () {
      this.$router.push("/join/entrance?applyCompanyId=" + this.applyCompanyId + "&applyCompanyOrderId=" + this.applyCompanyOrderId);
    },
    async goNext () {


      if (this.orderInfo.isAgent === '否') {

        if (!this.chooseBooth) {
          this.$Message.warning("请选择展位类型");
          return;
        }
        if (!this.chooseBooth.width1 || !this.chooseBooth.width2) {
          this.$Message.warning("请输入展位宽度");
          return;
        }
      }
      if (this.orderInfo.isAgent === '是') {
        if (!this.chooseBooth) {
          this.$Message.warning("请选择组团类型");
          return;
        }
        if (!this.chooseBooth.width1 || !this.chooseBooth.width2) {
          this.$Message.warning("请输入组团宽度");
          return;
        }
      }

      if (this.chooseOtherArr && this.chooseOtherArr.length > 0) {

        let finish = true;
        this.chooseOtherArr.map(c => {

          if (!c.durationValue && c.durationType !== '无') {
            finish = false;
            console.log(c.durationType, '111')
            this.$Message.warning("请选择" + c.pjName + "的" + c.durationType);
            return;
          }
          if (c.durationType === "时间段" && (!c.durationValue[0] || !c.durationValue[1]) && c.durationType != '无') {
            finish = false;
            console.log(this.chooseOtherArr, '222')
            this.$Message.warning("请选择" + c.pjName + "的" + c.durationType);
            return;
          }
          if (!c.orderNum && c.dePjNameGroupId != this.otherList3[this.fixedId].id) {
            finish = false;
            this.$Message.warning("请输入" + c.pjName + "的订购数量");
            return;
          }
        })
        if (!finish) return
      }
      // console.log("展位：",this.chooseBooth);
      // console.log("增值服务：",this.chooseOtherArr);

      let ApplyOtherOrderList = [];

      this.chooseOtherArr = Array.from(new Set(this.chooseOtherArr))
      console.log(this.chooseOtherArr, '12312312312')
      if (this.chooseOtherArr && this.chooseOtherArr.length > 0) {
        this.chooseOtherArr.map(c => {
          if (c.durationType === "时长") {
            ApplyOtherOrderList.push({
              "ApplyCompanyOrderId": this.applyCompanyOrderId,
              "DePjNameGroupId": c.dePjNameGroupId,
              "DePjNameGroupName": c.otherName,
              "Name": c.pjName,
              "Quantity": c.orderNum,
              "Unit": c.cunit,
              "UnitPrice": c.price,
              "TotalPrice": c.orderNum * c.price,
              "MonetaryUnit": c.pType,
              "DurationType": c.durationType,
              "Duration": Number(c.durationValue),
              "DurationUnit": c.durationUnit,
              "RexMoney": c.orderNum * c.price,
              "GpName": c.gpName || "",
              "GpCode": c.gpCode || "",
              "PjCode": c.pjCode || "",
              "GroupId": c.groupId || "",
              "PjFormat": c.pjFormat || "",
            })
          }
          if (c.durationType === "时间段") {
            ApplyOtherOrderList.push({
              "ApplyCompanyOrderId": this.applyCompanyOrderId,
              "DePjNameGroupId": c.dePjNameGroupId,
              "DePjNameGroupName": c.otherName,
              "Name": c.pjName,
              "Quantity": c.orderNum,
              "Unit": c.cunit,
              "UnitPrice": c.price,
              "TotalPrice": c.orderNum * c.price,
              "MonetaryUnit": c.pType,
              "DurationType": c.durationType,
              "DurationBegin": moment(c.durationValue[0]).format("YYYY-MM-DD"),
              "DurationEnd": moment(c.durationValue[1]).format("YYYY-MM-DD"),
              "RexMoney": c.orderNum * c.price,
              "GpName": c.gpName || "",
              "GpCode": c.gpCode || "",
              "PjCode": c.pjCode || "",
              "GroupId": c.groupId || "",
              "PjFormat": c.pjFormat || "",
            })
          }
          else {
            ApplyOtherOrderList.push({
              "ApplyCompanyOrderId": this.applyCompanyOrderId,
              "DePjNameGroupId": c.dePjNameGroupId,
              "DePjNameGroupName": '固定费用',
              "Name": c.pjName,
              "Quantity": 1,
              "Unit": c.cunit,
              "UnitPrice": c.price,
              "TotalPrice": c.price,
              "MonetaryUnit": c.pType,
              "DurationType": c.durationType,
              "DurationBegin": moment(c.durationBegin).format("YYYY-MM-DD"),
              "DurationEnd": moment(c.durationEnd).format("YYYY-MM-DD"),
              "RexMoney": c.price,
              "GpName": c.gpName || "",
              "GpCode": c.gpCode || "",
              "PjCode": c.pjCode || "",
              "GroupId": c.groupId || "",
              "PjFormat": c.pjFormat || "",

            })
          }
        })
      }

      let req = {};
      // 非组团
      if (this.orderInfo.isAgent === '否') {
        req = {
         "Id": this.applyCompanyOrderId,
          "ApplyCompanyId": this.applyCompanyId,
          "ExhibitionId": this.exhibitionId,
         
          "IsAgent": "否",
          "Remark": this.remark,
          "ApplyBoothOrderList": [
            {
              "ApplyCompanyOrderId": this.applyCompanyOrderId,
              "DePjNameGroupId": this.selectedExhall.id,
              "DePjNameGroupName": this.selectedExhall.name,
              "Name": this.chooseBooth.pjName,
              "Width": this.chooseBooth.width1,
              "Height": this.chooseBooth.width2,
              "Area": this.chooseBooth.width1 * this.chooseBooth.width2,
              "Unit": this.chooseBooth.cunit,
              "UnitPrice": this.chooseBooth.price,
              "TotalPrice": this.chooseBooth.width1 * this.chooseBooth.width2 * this.chooseBooth.price,
              "MonetaryUnit": this.chooseBooth.pType,
              "IsAgent": "否",
              "RexMoney": this.chooseBooth.width1 * this.chooseBooth.width2 * this.chooseBooth.price,
              "GpName": this.chooseBooth.gpName || "",
              "GpCode": this.chooseBooth.gpCode || "",
              "PjCode": this.chooseBooth.pjCode || "",
              "GroupId": this.chooseBooth.groupId || "",
              "PjFormat": this.chooseBooth.pjFormat || "",
              "BoothType": this.chooseBooth.boothType || ""
            }
          ],
          "ApplyOtherOrderList": ApplyOtherOrderList
        }
        if (this.chooseBooth.standstall > 1 && (this.chooseBooth.cunit.indexOf('㎡') != -1 || this.chooseBooth.cunit.indexOf('平米') != -1 || this.chooseBooth.cunit.indexOf('平方米') != -1)) {
          req.ApplyBoothOrderList[0].TotalPrice = (this.chooseBooth.width1 * this.chooseBooth.width2 * this.chooseBooth.price / parseInt(this.chooseBooth.standstall)).toFixed()

          req.ApplyBoothOrderList[0].RexMoney = (this.chooseBooth.width1 * this.chooseBooth.width2 * this.chooseBooth.price / parseInt(this.chooseBooth.standstall)).toFixed()
        }

      }
      // 组团
      if (this.orderInfo.isAgent === '是') {
        req = {
          "Id": this.applyCompanyOrderId,
          "ApplyCompanyId": this.applyCompanyId,
            "ExhibitionId": this.exhibitionId,
         
          "IsAgent": "是",
          "Remark": this.remark,
          "ApplyBoothOrderList": [
            {
              "ApplyCompanyOrderId": this.applyCompanyOrderId,
              "DePjNameGroupId": this.selectedExhall.id,
              "DePjNameGroupName": this.selectedExhall.name,
              "Name": this.chooseBooth.pjName,
              "Width": this.chooseBooth.width1,
              "Height": this.chooseBooth.width2,
              "Area": this.chooseBooth.width1 * this.chooseBooth.width2,
              "Unit": this.chooseBooth.cunit,
              "UnitPrice": this.chooseBooth.price,
              "TotalPrice": this.chooseBooth.width1 * this.chooseBooth.width2 * this.chooseBooth.price,
              "MonetaryUnit": this.chooseBooth.pType,
              "IsAgent": "是",
              "AgentName": this.selectedExhall.name,
              "DeTermId": this.selectedExhall.id,
              "RexMoney": this.chooseBooth.width1 * this.chooseBooth.width2 * this.chooseBooth.price,
              "GpName": this.chooseBooth.gpName || "",
              "GpCode": this.chooseBooth.gpCode || "",
              "PjCode": this.chooseBooth.pjCode || "",
              "GroupId": this.chooseBooth.groupId || "",
              "PjFormat": this.chooseBooth.pjFormat || "",
              "BoothType": this.chooseBooth.boothType || ""
            }
          ],
          "ApplyOtherOrderList": ApplyOtherOrderList
        }
      }

      // console.log(req);
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000)

      if (this.speenInfo.speed < 3) {
        console.log(this.inputShow, this.remark, '哈哈哈');
        if (this.inputShow && !this.remark) {
          this.$Message.warning("请输入产品类型");
          return
        }
        let info = await this.addApplyOrder(req);
        this.loading = false;
        if (info && info.successed) {
          this.$Message.success("保存成功！");
          if (this.groupId) {
            this.$router.push("/join/catalogue?id=" + this.exhibitionId + "&applyCompanyId=" + this.applyCompanyId + "&applyCompanyOrderId=" + this.applyCompanyOrderId + "&groupId=" + this.groupId);
          } else {
            this.$router.push("/join/catalogue?id=" + this.exhibitionId + "&applyCompanyId=" + this.applyCompanyId + "&applyCompanyOrderId=" + this.applyCompanyOrderId);
          }
        }else{
           this.msgErrors = info.errors[0].description
           this.errorMsgBool=true
        }
      } else {
        console.log(this.inputShow, this.remark, '哈哈哈');
        if (this.inputShow && !this.remark) {
          this.$Message.warning("请输入产品类型");
          return
        }
        console.log(req,'0000000000');
        let info = await this.editApplyOrder(req);
        console.log(info,'info');
        //let info = await this.editApplyOrder({...{Id: this.orderInfo.id}, ...req});
        this.loading = false;

        if (info && info.successed) {
          this.$Message.success("修改成功！");
          if (this.groupId) {
            this.$router.push("/join/catalogue?id=" + this.exhibitionId + "&applyCompanyId=" + this.applyCompanyId + "&applyCompanyOrderId=" + this.applyCompanyOrderId + "&groupId=" + this.groupId);
          } else {
            this.$router.push("/join/catalogue?id=" + this.exhibitionId + "&applyCompanyId=" + this.applyCompanyId + "&applyCompanyOrderId=" + this.applyCompanyOrderId);
          }
        }else{
          this.msgErrors = info.errors[0].description
           this.errorMsgBool=true
        }
      }


    },
    select (e) {
      console.log(e, '选中的展区')
      if (e.name.indexOf('其他') !== -1) {
        this.inputShow = true
      }
      else {
        this.inputShow = false
      }
      if (this.chooseBooth) {
        this.isChange = true;
        this.middleInfo = e;

      } else {
        this.selectedExhall = e;
        if (e.dePjNameList.length > 0) {
          e.dePjNameList.map(c => {
            c.width1 = 0;
            c.width2 = 0;
          })
        }
        this.boothList = e.dePjNameList;
        this.chooseBooth = null;

      }
    },
    changeNumber (item, e) {
      console.log(item, 'item')
      this.isAllChoose.push(item.dePjNameGroupId)
      this.isAllChoose = Array.from(new Set(this.isAllChoose))
      this.otherTotalPrice = 0;
      if (e > 0) {
        if (this.chooseOtherArr.indexOf(item) === -1) {
          this.chooseOtherArr.push(item);
        }
      }
      if (this.chooseOtherArr && this.chooseOtherArr.length > 0 && this.otherList3[this.fixedId].id != e.dePjNameGroupId) {
        this.chooseOtherArr.map(c => {
          if (c.orderNum && c.price) {
            this.otherTotalPrice += c.orderNum * c.price;
          }
          else {
            this.otherTotalPrice = this.otherTotalPrice
          }
        })
        //this.otherTotalPrice=this.otherTotalPrice+this.gudingprice
      } else {
        this.otherTotalPrice = 0;
      }
      for (let i = 0; i < this.otherList.length; i++) {

        if (this.chooseOtherArr.length > 0) {
          for (let j = 0; j < this.chooseOtherArr.length; j++) {
            if (this.otherList[i].id == this.chooseOtherArr[j].dePjNameGroupId) {
              this.otherList[i].isCheck = true
              console.log('777777777777')
              break
            }
            else {
              this.otherList[i].isCheck = false
            }
          }
        }
        else {
          this.otherList[i].isCheck = false
        }
      }
      for (let k = 0; k < this.otherList2.length; k++) {
        if (this.chooseOtherArr.length > 0) {

          for (let j = 0; j < this.chooseOtherArr.length; j++) {
            if (this.otherList2[k].id == this.chooseOtherArr[j].dePjNameGroupId) {
              this.otherList2[k].isCheck = true

              break
            }
            else {
              this.otherList2[k].isCheck = false
            }
          }
        }
        else {
          this.otherList2[k].isCheck = false
        }
      }

    },
    confirm () {
      this.isChange = false;
      this.selectedExhall = this.middleInfo;
      if (this.middleInfo.dePjNameList.length > 0) {
        this.middleInfo.dePjNameList.map(c => {
          c.width1 = 0;
          c.width2 = 0;
        })
      }
      this.boothList = this.middleInfo.dePjNameList;
      this.chooseBooth = null;
    },
    choose (e) {
      this.chooseBooth = e;
      console.log(e, 'eeeeeeeeeee');
    },
    changeWidth1 (e, i) {
      this.$set(this.boothList, i, this.boothList[i]);
    },
    changeWidth2 (e, i) {
      this.$set(this.boothList, i, this.boothList[i]);
    },
    allChoose (e, value) {
      console.log(this.isAllChoose, 'eeeeeeeee')
      console.log(this.chooseOtherArr, '666666')
      // this.ChooseCheck=value
      this.otherTotalPrice = 0;
      if (value) {
        e.isPack = true;
      } else {
        e.isPack = false;
      }
      if (this.isAllChoose.indexOf(e.id) !== -1 && e.isPack == false) {
        this.isAllChoose.splice(this.isAllChoose.indexOf(e.id), 1);
        if (e.dePjNameList.length > 0) {
          e.dePjNameList.map((c, i) => {
            if (this.chooseOtherArr.indexOf(c) !== -1 && c.netShow != '显示且必选') {

              this.chooseOtherArr.splice(this.chooseOtherArr.indexOf(c), 1);
            }
          })
        }

      } else if (value != false) {
        this.isAllChoose.push(e.id);
        if (e.dePjNameList.length > 0) {
          e.dePjNameList.map((c, i) => {
            if (this.chooseOtherArr.indexOf(c) === -1) {
              this.chooseOtherArr.push(c);
            }
          })
        }
      }
      if (this.chooseOtherArr && this.chooseOtherArr.length > 0 && e.type != '固定费用') {
        this.chooseOtherArr.map(c => {
          if (c.durationType !== '无') {
            this.otherTotalPrice += c.orderNum * c.price;
          }

        })
      } else if (this.chooseOtherArr && this.chooseOtherArr.length > 0 && e.type == '固定费用') {
        //this.otherTotalPrice =this.gudingprice
      } else {
        this.otherTotalPrice = 0;
      }
      console.log(this.chooseOtherArr, '删除了选中')
    },
    chooseOne (e, index) {
      this.isAllChoose.push(e.dePjNameGroupId)
      this.isAllChoose = Array.from(new Set(this.isAllChoose))
      this.chooseOtherArr = Array.from(new Set(this.chooseOtherArr))
      console.log(this.isAllChoose, 'this.isAllChoose')
      this.otherTotalPrice = 0;
      if (this.chooseOtherArr.indexOf(e) !== -1) {
        this.chooseOtherArr.splice(this.chooseOtherArr.indexOf(e), 1);
        console.log(this.chooseOtherArr, '2222222');
      } else {
        this.chooseOtherArr.push(e);

      }
      if (this.chooseOtherArr && this.chooseOtherArr.length > 0 && this.otherList3[this.fixedId].id != e.dePjNameGroupId) {
        this.chooseOtherArr.map(c => {
          if (c.orderNum && c.price) {
            this.otherTotalPrice += c.orderNum * c.price;
          }
          else {
            this.otherTotalPrice = this.otherTotalPrice
          }
        })
        //this.otherTotalPrice=this.otherTotalPrice+this.gudingprice
      } else if (this.chooseOtherArr && this.chooseOtherArr.length > 0 && this.otherList3[this.fixedId].id == e.dePjNameGroupId) {
        //this.chooseOtherArr=Array.from(new Set(this.chooseOtherArr))
        let price = 0
        let price1 = 0
        console.log(this.chooseOtherArr, '444')
        for (let i = 0; i < this.chooseOtherArr.length; i++) {
          if (this.otherList3[this.fixedId].id == this.chooseOtherArr[i].dePjNameGroupId) {
            price = price + this.chooseOtherArr[i].price
            this.gudingprice = price

          }
          else {
            console.log(i, '22231223123')
            price1 = price1 + this.chooseOtherArr[i].price * this.chooseOtherArr[i].orderNum
            this.gudingprice = price
            this.otherTotalPrice = price1;
          }

        }

        // this.otherTotalPrice=this.gudingprice
        console.log(this.chooseOtherArr, '777')
      } else {
        this.otherTotalPrice = 0;
        this.gudingprice = 0
      }

      for (let i = 0; i < this.otherList.length; i++) {

        if (this.chooseOtherArr.length > 0) {
          for (let j = 0; j < this.chooseOtherArr.length; j++) {
            if (this.otherList[i].id == this.chooseOtherArr[j].dePjNameGroupId) {
              this.otherList[i].isCheck = true
              console.log('777777777777')
              break
            }
            else {
              this.otherList[i].isCheck = false
            }
          }
        }
        else {
          this.otherList[i].isCheck = false
        }
      }
      for (let k = 0; k < this.otherList2.length; k++) {
        if (this.chooseOtherArr.length > 0) {

          for (let j = 0; j < this.chooseOtherArr.length; j++) {
            if (this.otherList2[k].id == this.chooseOtherArr[j].dePjNameGroupId) {
              this.otherList2[k].isCheck = true

              break
            }
            else {
              this.otherList2[k].isCheck = false
            }
          }
        }
        else {
          this.otherList2[k].isCheck = false
        }
      }
      for (let z = 0; z < this.otherList3.length; z++) {
        if (this.chooseOtherArr.length > 0) {

          for (let j = 0; j < this.chooseOtherArr.length; j++) {
            if (this.otherList3[z].id == this.chooseOtherArr[j].dePjNameGroupId) {
              this.otherList3[z].isCheck = true
              break
            }
            else {
              this.otherList3[z].isCheck = false
            }
          }
        }
        else {
          this.otherList3[z].isCheck = false
        }
      }
    },
  },
  created () {
    this.init();
  }
};
</script>

<style scoped lang='scss'>
.order {
  &-task {
    width: 100%;
    margin: 20px 0 50px;
    padding: 0 80px;
    display: flex;
    justify-content: space-between;
    color: #666;
    position: relative;
    .task-one {
      display: flex;
      flex-direction: column;
      align-items: center;
      z-index: 2;
      .box {
        width: 20px;
        height: 20px;
        background-color: #fff;
        box-shadow: 0px 2px 5px 0px #00bdca59;
        border-radius: 50%;
        margin-top: 10px;
        div {
          width: 14px;
          height: 14px;
          background-color: #8ba5bc;
          border-radius: 50%;
          margin: 3px auto 0;
        }
      }
    }
    .line {
      height: 8px;
      background-color: #d7e2e4;
      position: absolute;
      width: 998px;
      left: 108px;
      top: 37px;
      z-index: 1;
    }
    .ing {
      color: #00bdca;
      .box {
        div {
          background-color: #00bdca;
        }
      }
    }
    .finished {
      color: #00bdca;
      .box {
        background-color: #00bdca;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  &-header {
    width: 100%;
    height: 64px;
    background-color: #00bdca;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    p {
      line-height: 64px;
      font-size: 20px;
    }
    span {
      width: 30px;
      height: 1px;
      background-color: #fff;
      margin: 0 15px;
    }
  }

  &-exhall {
    padding: 30px 30px 0 30px;
    background-color: #fff;
    .exhall-header {
      width: 100%;
      height: 46px;
      background-color: #E5F8FA;
      color: #333;
      font-size: 18px;
      line-height: 46px;
      padding-left: 20px;
      font-weight: bold;
    }
    .exhall-list {
      display: flex;
      flex-wrap: wrap;
      padding: 20px 0 15px;
      background-color: #fff;
      .list-one {
        padding: 4px 20px;
        border: solid 1px #999;
        margin: 0 15px 15px 0;
        border-radius: 5px;
        cursor: pointer;
      }
      .selected {
        background-color: #db2a4b;
        border: solid 1px #db2a4b;
        color: #fff;
      }
    }
    .booth-list {
      background-color: #fff;
      padding: 20px 0 10px 0;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .booth-one {
        width: 560px;
        height: 230px;
        background-color: #f5f5f5;
        margin-bottom: 20px;
        padding: 20px;
        position: relative;
        cursor: pointer;

        .f {
          display: flex;
          justify-content: space-between;
          p {
            width: 90%;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            font-size: 20px;
            color: #333;
          }
          p:last-child {
            text-align: right;
            font-size: 14px;
          }
        }
        .s {
          margin-top: 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          p {
            width: 50%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 16px;
            color: #333;
          }
          p:last-child {
            text-align: right;
            font-size: 24px;
            color: #db2a4b;
          }
        }
        .t {
          margin-top: 10px;
          color: #333;
        }
        .l {
          color: #333;
          font-size: 16px;
          margin-top: 30px;
        }
        .choose {
          position: absolute;
          right: 0;
          bottom: 0;
          width: 0;
          height: 0;
          border-bottom: 46px solid #d9d9d9;
          border-left: 46px solid transparent;
          i {
            position: absolute;
            top: 10px;
            left: -30px;
            color: #fff;
            font-size: 30px;
          }
        }
        .choosed {
          border-bottom: 46px solid #db2a4b;
        }
      }
      .chooseboothOne {
        border: 1px solid red;
      }
    }
  }

  &-other {
    background-color: #fff;
    padding: 0 30px 30px;
    .other-header {
      width: 100%;
      height: 46px;
      background-color: #E5F8FA;
      color: #333;
      font-size: 18px;
      line-height: 46px;
      padding-left: 20px;
      font-weight: bold;
    }
    .other-online {
      padding: 0 30px;
      margin-bottom: 30px;
      font-size: 16px;
      a {
        text-decoration: underline;
      }
    }
    .other-list {
      width: 1080px;
      margin: 0 auto 30px;
      border: solid 1px #e5e5e5;
      .top {
        background-color: #f5f5f5;
        height: 46px;
        line-height: 46px;
        position: relative;
        padding: 0 20px;
        font-size: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #333;
        border-bottom: 1px solid #e5e5e5;
        .r {
          cursor: pointer;
          display: flex;
          align-items: center;
          i {
            font-size: 20px;
            margin-left: 5px;
          }
        }
      }
      .content {
        padding: 20px 20px 0 20px;
        .content-one {
          width: 100%;
          margin: 0 auto 20px;
          border: 1px solid #e5e5e5;

          .title {
            width: 100%;
            height: 46px;
            background-color: #f5f5f5;
            line-height: 46px;
            font-size: 16px;
            color: #333;
            padding-left: 20px;
            border-bottom: 1px solid #e5e5e5;
          }
          .details {
            width: 100%;
            height: 230px;
            display: flex;
            .text {
              width: 50%;
              height: 100%;
              padding: 0 30px;
              position: relative;
              cursor: pointer;
              color: #333;
              font-size: 16px;
              .time {
                width: 100%;
                display: flex;
                align-items: center;
                margin-top: 20px;
                span {
                  width: 100px;
                }
              }
              .choose {
                position: absolute;
                right: 0;
                bottom: 0;
                width: 0;
                height: 0;
                border-bottom: 46px solid #d9d9d9;
                border-left: 46px solid transparent;
                i {
                  position: absolute;
                  top: 10px;
                  left: -30px;
                  color: #fff;
                  font-size: 30px;
                }
              }
              .choosed {
                border-bottom: 46px solid #db2a4b;
              }
            }
            img {
              width: 50%;
              height: 100%;
            }
          }
        }
      }
    }
    .total {
      width: 100%;
      height: 173px;
      background-color: #f5f5f5;
      border: solid 1px #e5e5e5;
      text-align: right;
      font-size: 16px;
      color: #333;
      padding: 30px;
      p {
        line-height: 1;
      }
      span {
        color: #db2a4b;
      }
    }
  }

  &-btn {
    margin-top: 50px;
    margin-bottom: 80px;
    text-align: center;
    button {
      width: 200px;
      height: 48px;
      background-color: #024c8b;
      font-size: 16px;
      border-color: #024c8b;
    }
  }
}
.change-modal {
  padding: 6px 16px 8px;
  &-top {
    display: flex;
    align-items: center;
    p {
      padding-left: 12px;
      color: #17233d;
      font-size: 16px;
      line-height: 42px;
    }
  }
  &-bottom {
    margin-left: 40px;
  }
  &-btn {
    text-align: right;
    margin-top: 20px;
  }
}
</style>
